import dynamic from 'next/dynamic';
import { YouTubeProps } from './YoutubeVideo';

export const DynamicYoutubeVideo = dynamic<YouTubeProps>(
    () => import('./YoutubeVideo').then(md => md.YoutubeVideo),
    {
        ssr: false,
    },
);
